import orderBy from 'lodash/orderBy'
import { PROMO_SCHEDULE_STATUS_SORT_ORDER } from './promoScheduleConstants'
import { getPromoScheduleStatus, isSelectablePromoSchedule } from './getPromoScheduleStatus'

export const filterSelectablePromoSchedules = (schedules = [], now = new Date()) => {
  const selectable = schedules
    .filter((schedule) => isSelectablePromoSchedule(schedule, now))
    .map((schedule) => ({
      ...schedule,
      status: getPromoScheduleStatus(schedule, now),
    }))

  return orderBy(
    selectable,
    [
      (schedule) => PROMO_SCHEDULE_STATUS_SORT_ORDER[schedule.status] ?? 99,
      (schedule) => schedule.startedAt || '',
    ],
    ['asc', 'desc']
  )
}

export default filterSelectablePromoSchedules
